<template>
  <div class="homebox">
    <div class="mainbox" :style="'height:calc(100% - ' + mainboxHeight +'px'">
      <router-view></router-view>
    </div>
    <div class="tabbar" ref="tabbar"><tabbar></tabbar></div>
  </div>
</template>

<script>
import {getdaily} from '../api/api.js'
import global from '../global/global.vue'
import tabbar from './public/tabbar.vue'
import mindex from './pages/mindex.vue'
export default {
  name: 'home',
  components:{tabbar,mindex},
  data () {
    return {
      mainboxHeight:0,
       
      //globalHttpUrl: global.httpUrl,
      //bgurl:global.bgurl

      }
  
  },
  beforeCreate() {
    //global.httpUrl = 'nihao56'
  },
  mounted() {
    this.mainboxHeight = this.$refs.tabbar.offsetHeight;
  },
  methods: {
    
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.homebox,.mainbox{ height: 100%;background: #fff}
</style>



// WEBPACK FOOTER //
// src/components/home.vue